export default __webpack_public_path__ + "static/media/Blog3_1.5ab6c8d0.jpg";